import { getPlanAmountFromName } from './plans';
import { formatMbToGb } from './formatters';
import { LOWER_DATA_PRODUCTS_IDS } from '../constants/products';
import { US_STATES } from '../constants';

export const parseJwt = (token) => {
  if (!token) {
    return null;
  }
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const validateEmail = (email) => {
  var reEmail =
    // eslint-disable-next-line
    /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
  if (!email.match(reEmail)) {
    return false;
  }

  return true;
};

export const getDeviceSnsFromSubs = (subscriptionsData) => {
  const deviceSns = subscriptionsData?.subscriptions?.map((item) => {
    return getDeviceSn(item.properties);
  });

  return Array.from(new Set(deviceSns));
};

export const getDeviceSn = (properties) => {
  let deviceSn = '';

  if (!properties || !properties.length) {
    return deviceSn;
  }

  const sanitizedProperties = properties
    .filter(
      ({ name, value }) =>
        typeof name === 'string' && typeof value === 'string',
    )
    .map(({ name, value }) => {
      const sanitizedName = name
        .toLowerCase()
        .trim()
        .replace(/[^\w\s]/g, '')
        .replace(/\s+/g, ' ');
      const sanitizedValue = value.toLowerCase().trim().replace(/[^\w]/g, '');
      return { name: sanitizedName, value: sanitizedValue };
    });

  const possibleNames = [
    'device sn',
    'sn',
    'device serial number',
    'serial number',
    'device_sn',
    'device',
  ];

  for (let possibleName of possibleNames) {
    const property = sanitizedProperties.find(
      ({ name }) => name === possibleName,
    );
    if (property) {
      deviceSn = property.value;
      break;
    }
  }

  if (!deviceSn) {
    let property = sanitizedProperties.find(({ name }) => {
      const splittedName = name.split(' ');
      return splittedName.includes('sn');
    });
    if (!property) {
      property = sanitizedProperties.find(({ name }) => {
        const splittedName = name.split(' ');
        return splittedName.includes('device');
      });
    }
    if (property) {
      deviceSn = property.value;
    }
  }

  return deviceSn;
};

export const getUsageType = (usage) => {
  if (!usage) {
    return null;
  }

  const { total, balance } = usage;
  const usageInPercent =
    (parseFloat(total - balance) / parseFloat(total)) * 100;

  if (usageInPercent >= 100) {
    return 'Out Of Data';
  } else if (usageInPercent < 50) {
    return 'Low Usage';
  } else if (usageInPercent < 75) {
    return 'Medium Usage';
  } else {
    return 'High Usage';
  }
};

export const getOrderIdsFromCharges = (chargeData) => {
  const deviceSns = chargeData?.charges?.map((item) => {
    return item.external_order_id.ecommerce;
  });

  return Array.from(new Set(deviceSns));
};

export const isCpeDevice = (type) => {
  if (!type) {
    return false;
  }

  const cpeRoutersTypes = [
    'CPE Router',
    'CPE Router (WA)',
    'LTE Router',
    'LTE Router (WA)',
  ];

  return cpeRoutersTypes.includes(type);
};

export const getProductIdsFromSubsWithUpcomingPlan = (subscriptions) => {
  let deviceIds = [];
  for (const subscription of subscriptions) {
    if (!subscription?.meta?.usage || subscription.status === 'cancelled') {
      continue;
    }
    const upcomingTotalUsage = getPlanAmountFromName(
      subscription?.variant_title,
    ).toString();
    const currentTotalUsage = formatMbToGb(
      subscription?.meta?.usage?.total || 0,
    );
    const productId = subscription?.external_product_id?.ecommerce;
    if (
      productId &&
      upcomingTotalUsage !== currentTotalUsage &&
      !deviceIds.includes(productId)
    ) {
      deviceIds.push(productId);
    }
  }

  return deviceIds;
};

export const getPrice = (subscription) => {
  if (!subscription?.meta?.usage?.total || !subscription?.meta?.productInfo) {
    return subscription.price;
  }

  const upcomingTotalUsage = getPlanAmountFromName(
    subscription?.variant_title,
  ).toString();
  const currentTotalUsage = `${formatMbToGb(
    subscription?.meta?.usage?.total || 0,
  )}gb`;

  if (upcomingTotalUsage === currentTotalUsage) {
    return subscription.price;
  }

  const currentVariant = subscription?.meta?.productInfo?.variants.find(
    (variant) => {
      return variant.title.toLowerCase().split(' ').includes(currentTotalUsage);
    },
  );
  return (
    currentVariant?.prices[0]?.compare_at_price ||
    currentVariant?.prices[0]?.unit_price ||
    ''
  );
};

export const isLowerDataProduct = (productId) => {
  return LOWER_DATA_PRODUCTS_IDS.some((id) => id === productId);
};

export const getStateCode = (fullName) => {
  if (!fullName) return '';
  const state = US_STATES.find(
    (s) => s.label.toLowerCase() === fullName.toLowerCase(),
  );
  return state ? state.value : '';
};

export const isInPossibleReactivation = (subscription) => {
  if (!subscription || !subscription?.meta?.status) {
    return false;
  }
  return (
    !!subscription?.cancelled_at === false &&
    subscription?.meta?.status !== 'active'
  );
};
